/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestions.defs'
export { main as default } from './getSuggestions.defs'
